/**
 * List of country codes supported by https://www.npmjs.com/package/i18n-iso-countries
 */

export enum ISOCountryCode {
  // A
  Afghanistan = 'AF',
  Albania = 'AL',
  Algeria = 'DZ',
  AmericanSamoa = 'AS',
  Andorra = 'AD',
  Angola = 'AO',
  Anguilla = 'AI',
  Antarctica = 'AQ',
  AntiguaAndBarbuda = 'AG',
  Argentina = 'AR',
  Armenia = 'AM',
  Aruba = 'AW',
  Australia = 'AU',
  Austria = 'AT',
  Azerbaijan = 'AZ',

  // B
  Bahamas = 'BS',
  Bahrain = 'BH',
  Bangladesh = 'BD',
  Barbados = 'BB',
  Belarus = 'BY',
  Belgium = 'BE',
  Belize = 'BZ',
  Benin = 'BJ',
  Bermuda = 'BM',
  Bhutan = 'BT',
  Bolivia = 'BO',
  BosniaHerzegovina = 'BA',
  Botswana = 'BW',
  BouvetIsland = 'BV',
  Brazil = 'BR',
  BritishIndianOceanTerritory = 'IO',
  BruneiDarussalam = 'BN',
  Bulgaria = 'BG',
  BurkinaFaso = 'BF',
  Burundi = 'BI',

  // C
  Cambodia = 'KH',
  Cameroon = 'CM',
  Canada = 'CA',
  CanaryIslands = 'IC' /* Exceptionally reserved */,
  CapeVerde = 'CV',
  CaymanIslands = 'KY',
  CentralAfricanRepublic = 'CF',
  Chad = 'TD',
  Chile = 'CL',
  China = 'CN',
  ChristmasIsland = 'CX',
  CocosIslands = 'CC',
  Colombia = 'CO',
  Comoros = 'KM',
  RepublicCongo = 'CG',
  DemocraticRepublicCongo = 'CD',
  CookIslands = 'CK',
  CostaRica = 'CR',
  IvoryCoast = 'CI',
  Croatia = 'HR',
  Cuba = 'CU',
  Cyprus = 'CY',
  Czechia = 'CZ',

  // D
  Denmark = 'DK',
  Djibouti = 'DJ',
  Dominica = 'DM',
  DominicanRepublic = 'DO',

  // E
  Ecuador = 'EC',
  Egypt = 'EG',
  ElSalvador = 'SV',
  EquatorialGuinea = 'GQ',
  Eritrea = 'ER',
  Estonia = 'EE',
  Ethiopia = 'ET',

  // F
  FalklandIslands = 'FK',
  FaroeIslands = 'FO',
  Fiji = 'FJ',
  Finland = 'FI',
  France = 'FR',
  FrenchGuiana = 'GF',
  FrenchPolynesia = 'PF',
  FrenchSouthernTerritories = 'TF',

  // G
  Gabon = 'GA',
  Gambia = 'GM',
  Georgia = 'GE',
  Germany = 'DE',
  Ghana = 'GH',
  Gibraltar = 'GI',
  Greece = 'GR',
  Greenland = 'GL',
  Grenada = 'GD',
  Guadeloupe = 'GP',
  Guam = 'GU',
  Guatemala = 'GT',
  Guinea = 'GN',
  GuineaBissau = 'GW',
  Guyana = 'GY',

  // H
  Haiti = 'HT',
  HeardIslandMcDonaldIslands = 'HM',
  Vatican = 'VA',
  Honduras = 'HN',
  HongKong = 'HK',
  Hungary = 'HU',

  // I
  Iceland = 'IS',
  India = 'IN',
  Indonesia = 'ID',
  Iran = 'IR',
  Iraq = 'IQ',
  Ireland = 'IE',
  Israel = 'IL',
  Italy = 'IT',

  // J
  Jamaica = 'JM',
  Japan = 'JP',
  Jordan = 'JO',

  // K
  Kazakhstan = 'KZ',
  Kenya = 'KE',
  Kiribati = 'KI',
  NorthKorea = 'KP',
  SouthKorea = 'KR',
  Kuwait = 'KW',
  Kyrgyzstan = 'KG',

  // L
  Lao = 'LA',
  Latvia = 'LV',
  Lebanon = 'LB',
  Lesotho = 'LS',
  Liberia = 'LR',
  Libya = 'LY',
  Liechtenstein = 'LI',
  Lithuania = 'LT',
  Luxembourg = 'LU',

  // M
  Macao = 'MO',
  Madagascar = 'MG',
  Malawi = 'MW',
  Malaysia = 'MY',
  Maldives = 'MV',
  Mali = 'ML',
  Malta = 'MT',
  MarshallIslands = 'MH',
  Martinique = 'MQ',
  Mauritania = 'MR',
  Mauritius = 'MU',
  Mayotte = 'YT',
  Mexico = 'MX',
  Micronesia = 'FM',
  Moldova = 'MD',
  Monaco = 'MC',
  Mongolia = 'MN',
  Montserrat = 'MS',
  Morocco = 'MA',
  Mozambique = 'MZ',
  Myanmar = 'MM',

  // N
  Namibia = 'NA',
  Nauru = 'NR',
  Nepal = 'NP',
  Netherlands = 'NL',
  NewCaledonia = 'NC',
  NewZealand = 'NZ',
  Nicaragua = 'NI',
  Niger = 'NE',
  Nigeria = 'NG',
  Niue = 'NU',
  NorfolkIsland = 'NF',
  NorthMacedonia = 'MK',
  NorthernMarianaIslands = 'MP',
  Norway = 'NO',

  // O
  Oman = 'OM',

  // P
  Pakistan = 'PK',
  Palau = 'PW',
  Palestine = 'PS',
  Panama = 'PA',
  PapuaNewGuinea = 'PG',
  Paraguay = 'PY',
  Peru = 'PE',
  Philippines = 'PH',
  PitcairnIslands = 'PN',
  Poland = 'PL',
  Portugal = 'PT',
  PuertoRico = 'PR',

  // Q
  Qatar = 'QA',

  // R
  Reunion = 'RE',
  Romania = 'RO',
  Russia = 'RU',
  Rwanda = 'RW',

  // S
  SaintHelena = 'SH',
  SaintKittsNevis = 'KN',
  SaintLucia = 'LC',
  SaintPierreMiquelon = 'PM',
  SaintVincentGrenadines = 'VC',
  Samoa = 'WS',
  SanMarino = 'SM',
  SaoTomePrincipe = 'ST',
  SaudiArabia = 'SA',
  Senegal = 'SN',
  Seychelles = 'SC',
  SierraLeone = 'SL',
  Singapore = 'SG',
  Slovakia = 'SK',
  Slovenia = 'SI',
  SolomonIslands = 'SB',
  Somalia = 'SO',
  SouthAfrica = 'ZA',
  SouthGeorgiaSouthSandwichIslands = 'GS',
  Spain = 'ES',
  SriLanka = 'LK',
  Sudan = 'SD',
  Suriname = 'SR',
  SvalbardJanMayen = 'SJ',
  Eswatini = 'SZ',
  Sweden = 'SE',
  Switzerland = 'CH',
  SyrianArabRepublic = 'SY',

  // T
  Taiwan = 'TW',
  Tajikistan = 'TJ',
  Tanzania = 'TZ',
  Thailand = 'TH',
  TimorLeste = 'TL',
  Togo = 'TG',
  Tokelau = 'TK',
  Tonga = 'TO',
  TrinidadTobago = 'TT',
  Tunisia = 'TN',
  Turkey = 'TR',
  Turkmenistan = 'TM',
  TurksCaicosIslands = 'TC',
  Tuvalu = 'TV',

  // U
  Uganda = 'UG',
  Ukraine = 'UA',
  UnitedArabEmirates = 'AE',
  UnitedKingdom = 'GB',
  UnitedStatesAmerica = 'US',
  UnitedStatesMinorOutlyingIslands = 'UM',
  Uruguay = 'UY',
  Uzbekistan = 'UZ',

  // V
  Vanuatu = 'VU',
  Venezuela = 'VE',
  Vietnam = 'VN',
  VirginIslandsBritish = 'VG',
  VirginIslandsUS = 'VI',

  // W
  WallisFutuna = 'WF',
  WesternSahara = 'EH',

  // Y
  Yemen = 'YE',

  // Z
  Zambia = 'ZM',
  Zimbabwe = 'ZW',
  AlandIslands = 'AX',
  BonaireSintEustatiusSaba = 'BQ',
  Curacao = 'CW',
  Guernsey = 'GG',
  IsleofMan = 'IM',
  Jersey = 'JE',
  Montenegro = 'ME',
  SaintBarthelemy = 'BL',
  SaintMartin = 'MF',
  Serbia = 'RS',
  SintMaarten = 'SX',
  SouthSudan = 'SS',
  Kosovo = 'XK',
}
